import { get, patch } from "aws-amplify/api";
import { API_NAME_VELAVU, normalizePromiseError, operationToJSON } from "../util/amplify-utils";
export default class VelavuAPIOrganizations {
    //This method returns information about the organization to which the current user belongs
    getOrganization() {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: "/organization",
        })));
    }
    //This method allows the user's organization name to be modified.
    updateOrganization(params) {
        return normalizePromiseError(operationToJSON(patch({
            apiName: API_NAME_VELAVU,
            path: "/organization",
            options: {
                body: params,
            },
        })));
    }
    //This method returns a list of groups and categories that are assigned to assets in the system
    getOrganizationMetaAssets() {
        return normalizePromiseError(operationToJSON(get({
            apiName: API_NAME_VELAVU,
            path: "/organization/meta/assets",
        })));
    }
}
//# sourceMappingURL=velavu-api-organizations.js.map